module.exports = __webpack_public_path__ + "img/person.cca3ed3a.png";